import styled from 'styled-components';
import Color from './Color';

const Textarea = styled.textarea`
  resize: none;
  padding: 2px;
  line-height: 18px;
  font-size: 12px;
  font-family: 'Hiragino Kaku Gothic Pro';
  color: ${Color.denim};
`;

export default Textarea;
